export default __webpack_public_path__ + "locales/sk/Payments.json?hash=ce59359665583a389978fe6a3e7a9de1";